document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("button-nawykownia");
  if(button) {
    button.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WM6UcG']);
    });
  }
  const button2 = document.getElementById("button-nawykownia2");
  if(button2) {
    button2.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WM6UcG']);
    });
  }
  
  const faqSections = document.querySelectorAll('.healthClaims');
  faqSections.forEach(function (section) {
    if (section.dataset.initialized === "true") {
      return;
    }

    section.dataset.initialized = "true";

    const faqItems = section.querySelectorAll('.healthClaims__itemQuestion');
    
    faqItems.forEach(function (item) {
      item.addEventListener('click', function () {
        const parent = this.parentNode;
        const isOpened = parent.classList.contains('opened');

        section.querySelectorAll('.healthClaims__item.opened').forEach(function (openedItem) {
          openedItem.classList.remove('opened');
        });

        if (!isOpened) {
          parent.classList.add('opened');
        }
      });
    });
  });
});